import "@ui5/webcomponents-base/dist/Assets-fetch.js"; // Base i18n
import "@ui5/webcomponents-localization/dist/Assets-fetch.js"; // CLDR
import "@ui5/webcomponents-theming/dist/Assets-fetch.js"; // Theming
import "@ui5/webcomponents-icons/dist/Assets-fetch.js"; // Icons texts

// own main package assets
import "./generated/json-imports/Themes-fetch.js";
import "./generated/json-imports/i18n-fetch.js";
